<template>
  <v-card>
    <v-card-text>
      <v-row dense class="text--primary">
        <v-col cols="12" sm="6" md="7" class="headline">
          {{ resposta.transportadora.pessoa.nome }}
          <px-popover-transportador :transportador="resposta.transportadora"/>
        </v-col>
        <v-col cols="12"
               sm="6"
               md="5"
               class="d-flex align-center justify-end headline blue--text text--darken-3">
          {{ resposta.total | currency }}
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    resposta: Object,
  },
  data() {
    return {};
  },
};
</script>
